import { useState } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { useTier } from "@/context/TierContext";
import { Switch } from "@/components/ui/switch";
import { toast } from "sonner";
import { BellRing } from "lucide-react";

export function CheckupReminderToggle() {
  const { user, setUser } = useAuth();
  const { isPremium } = useTier();
  const [saving, setSaving] = useState(false);

  if (!isPremium) return null;

  const enabled = !!user?.checkup_reminders;

  const toggle = async (val) => {
    setSaving(true);
    setUser((u) => ({ ...u, checkup_reminders: val }));
    try {
      await api.patch("/me/preferences", { checkup_reminders: val });
      toast.success(val ? "Monthly checkup reminders on" : "Reminders off");
    } catch {
      setUser((u) => ({ ...u, checkup_reminders: !val }));
      toast.error("Could not update reminders");
    } finally { setSaving(false); }
  };

  return (
    <div className="w-full rounded-2xl border border-[#E2E8F0] bg-white p-6" data-testid="reminders-section">
      <h2 className="font-heading text-lg font-semibold text-navy flex items-center gap-2"><BellRing size={18} /> Email reminders</h2>
      <div className="mt-4 flex items-center justify-between gap-4">
        <div>
          <p className="text-sm font-medium text-navy">Monthly rental checkup</p>
          <p className="text-xs text-[#94A3B8]">We'll email you once a month to complete your checkup. Sent to your account email only.</p>
        </div>
        <Switch data-testid="checkup-reminder-switch" checked={enabled} disabled={saving} onCheckedChange={toggle} />
      </div>
    </div>
  );
}
